module.exports = __webpack_public_path__ + "fa-brands-400.svg?5bf145531213545e03ff41cd27df7d2b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.svg
// module id = 226
// module chunks = 0